module.exports = __webpack_public_path__ + "img/gywmdz.2efe419c.png";